<template>
  <footer class="footer">
    <div class="footer__pole" aria-hidden="true" />
    <div class="footer__inner">
      <div class="footer__grid">
        <!-- Brand -->
        <div class="footer__brand">
          <router-link to="/" class="brand">
            <span class="brand__mark"><span class="brand__pole" /></span>
            <span class="brand__name">Salon <em>Zap</em></span>
          </router-link>
          <p class="footer__about">
            Online booking, client checkout and deposits, client profiles, and commission &amp; tip tracking for
            salons, barbershops, nail and lash studios, spas, tattoo shops, and mobile pros. One app for the front desk and the floor.
          </p>
          <div class="footer__verticals">
            <span v-for="v in verticals" :key="v">{{ v }}</span>
          </div>
        </div>

        <!-- Company -->
        <div>
          <h4 class="footer__heading">Company</h4>
          <ul class="footer__links">
            <li><router-link to="/why">Why Salon Zap</router-link></li>
            <li><router-link to="/features">Features</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/blog">Blog</router-link></li>
            <li><router-link to="/tribzz">Tribzz for your business</router-link></li>
          </ul>
        </div>

        <!-- Support -->
        <div>
          <h4 class="footer__heading">Support</h4>
          <ul class="footer__links">
            <li><router-link to="/documentation">Documentation</router-link></li>
            <li><router-link to="/help">Help Center</router-link></li>
            <li><router-link to="/contact">Contact Us</router-link></li>
            <li><router-link to="/demo">Request Demo</router-link></li>
            <li><router-link to="/login">Client Portal</router-link></li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h4 class="footer__heading">Legal</h4>
          <ul class="footer__links">
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Service</router-link></li>
            <li><router-link to="/cookies">Cookie Policy</router-link></li>
            <li><router-link to="/security">Security</router-link></li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h4 class="footer__heading">Contact</h4>
          <ul class="footer__contact">
            <li>
              <v-icon small color="#C7A66B">mdi-email-outline</v-icon>
              <a href="mailto:ricosevere@codeforgedev.com">ricosevere@codeforgedev.com</a>
            </li>
            <li>
              <v-icon small color="#C7A66B">mdi-phone-outline</v-icon>
              <a href="tel:+13392418725">(339) 241-8725</a>
            </li>
            <li>
              <v-icon small color="#C7A66B">mdi-map-marker-outline</v-icon>
              <span>United States</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer__bottom">
        <p>© {{ currentYear }} Salon Zap. All rights reserved.</p>
        <div class="footer__meta">
          <span>Made in USA</span>
          <span class="dot">•</span>
          <span>Web, iOS &amp; Android</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SalonFooter",
  data() {
    return {
      // Same business types the app adapts to (config/serviceCategories.js in the app).
      verticals: [
        "Hair salons",
        "Barbershops",
        "Nail studios",
        "Lash & brow",
        "Skin & waxing",
        "Makeup artists",
        "Tattoo & piercing",
        "Spas & massage",
        "Mobile pros",
      ],
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,500;0,9..144,600;1,9..144,500&family=DM+Sans:wght@400;500;600;700&display=swap");

.footer {
  position: relative;
  background: #161c2c;
  color: rgba(246, 241, 232, 0.68);
  font-family: "DM Sans", -apple-system, BlinkMacSystemFont, sans-serif;
  overflow: hidden;
}

.footer__pole {
  height: 6px;
  background: repeating-linear-gradient(90deg, #b23a33 0 18px, #f4efe6 18px 36px, #2f4a7a 36px 54px, #f4efe6 54px 72px);
  background-size: 72px 100%;
  animation: slide 6s linear infinite;
}

.footer__inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 64px 24px 28px;
}

.footer__grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr 1.4fr;
  gap: 36px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(246, 241, 232, 0.1);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.brand__mark {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f6f1e8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand__pole {
  width: 10px;
  height: 26px;
  border-radius: 6px;
  background: repeating-linear-gradient(-45deg, #b23a33 0 4px, #fff 4px 8px, #2f4a7a 8px 12px, #fff 12px 16px);
}

.brand__name {
  font-family: "Fraunces", Georgia, serif;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #f6f1e8;
}

.brand__name em {
  font-style: italic;
  font-weight: 500;
  color: #c7a66b;
}

.footer__about {
  margin: 18px 0 18px;
  max-width: 320px;
  font-size: 14px;
  line-height: 1.7;
  color: rgba(246, 241, 232, 0.55);
}

.footer__verticals {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 340px;
}

.footer__verticals span {
  font-size: 11.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(246, 241, 232, 0.14);
  color: rgba(246, 241, 232, 0.6);
}

.footer__heading {
  margin: 0 0 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #c7a66b;
}

.footer__links,
.footer__contact {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.footer__links a,
.footer__contact a {
  font-size: 14px;
  color: rgba(246, 241, 232, 0.72);
  text-decoration: none;
  transition: color 0.15s ease;
}

.footer__links a:hover,
.footer__contact a:hover {
  color: #fff;
}

.footer__contact li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  min-width: 0;
}

.footer__contact a {
  overflow-wrap: anywhere;
}

.footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 24px;
  font-size: 13px;
  color: rgba(246, 241, 232, 0.45);
}

.footer__bottom p {
  margin: 0;
}

.footer__meta {
  display: flex;
  gap: 10px;
  font-weight: 600;
}

.dot {
  opacity: 0.5;
}

@keyframes slide {
  from { background-position: 0 0; }
  to { background-position: 72px 0; }
}

@media (prefers-reduced-motion: reduce) {
  .footer__pole { animation: none; }
}

@media (max-width: 960px) {
  .footer__grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .footer__brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 600px) {
  .footer__inner {
    padding: 48px 16px 24px;
  }
  .footer__grid {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }
  .footer__grid > div:last-child {
    grid-column: 1 / -1;
  }
  .footer__bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>